var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpAndSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0053 8.85377C38.2246 21.2565 25.9764 32.0277 19.2599 35.9809C19.0794 36.0872 18.8587 35.953 18.8587 35.7436V31.2809C18.8587 31.1509 18.7633 31.0382 18.6361 31.0114C7.29625 28.6239 5.16507 21.7082 5.01664 17.9347C4.55574 6.21801 13.7833 2.00001 18.8587 2C25.7629 1.99998 29.3135 6.3542 31.0053 8.85377Z",
    stroke: "#242529",
    strokeWidth: 2.9386
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0777 17.3702L22.0777 17.3702L22.0803 17.3673L23.239 16.0799C24.0138 15.24 24.5078 14.0671 24.5078 12.7788L24.5078 12.7779C24.4925 9.56423 22.0881 6.93546 19.0992 6.93546C16.4964 6.93546 14.3344 8.93134 13.8214 11.5576C13.669 12.3382 14.33 12.9537 15.0719 12.9537H15.3224C16.0866 12.9537 16.6394 12.3183 16.8973 11.6882C17.2753 10.7644 18.1214 10.1356 19.0992 10.1356C20.4215 10.1356 21.5095 11.2915 21.5095 12.7627C21.5095 13.4864 21.2312 14.1498 20.8008 14.6314C20.8005 14.6317 20.8003 14.632 20.8 14.6322L19.1818 16.4014C19.1817 16.4015 19.1817 16.4015 19.1816 16.4016C18.4627 17.1805 17.9486 18.1865 17.7308 19.3037C17.5787 20.0842 18.2394 20.6996 18.9814 20.6996H19.3359C20.1003 20.6996 20.6608 20.0769 20.7745 19.3661C20.8538 18.8707 20.9968 18.5722 21.2017 18.3039C21.3069 18.166 21.4305 18.0336 21.5776 17.8834C21.6189 17.8411 21.6623 17.7973 21.7074 17.7517C21.8207 17.6373 21.9453 17.5114 22.0777 17.3702ZM18.5167 25.6998H19.986C20.7407 25.6998 21.3525 25.088 21.3525 24.3333V23.1579C21.3525 22.4032 20.7407 21.7914 19.986 21.7914H18.5167C17.7621 21.7914 17.1503 22.4032 17.1503 23.1579V24.3333C17.1503 25.088 17.7621 25.6998 18.5167 25.6998Z",
    fill: "#242529",
    stroke: "#242529",
    strokeWidth: 0.382018,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpAndSupport);
export default __webpack_public_path__ + "static/media/Help_and_support.81dc33b3c2d1d3ad9bc222c29b58a858.svg";
export { ForwardRef as ReactComponent };